import * as z from "zod";

export const conciergeAnalytics = {
  name: "conciergeAnalytics" as const,
  input: z.object({
    start: z.date(),
    end: z.date(),
    platform: z.string().optional(),
    attributionWindow: z.number().optional(),
  }),

  output: z.object({
    // Sales metrics
    totalSales: z.number(),
    totalSalesPercentChange: z.number(),
    totalOrders: z.number(),
    totalOrdersPercentChange: z.number(),
    averageOrderValue: z.number(),
    averageOrderValuePercentChange: z.number(),
    nonEngagedAverageOrderValue: z.number(),
    nonEngagedAverageOrderValuePercentChange: z.number(),

    // Session metrics
    totalSessionsCheckoutCompleted: z.number(),
    totalSessionsWithConciergeAttributedCheckoutCompleted: z.number(),
    totalSessionsWithConciergeInteracted: z.number(),
    totalSessionsWithConciergePresent: z.number(),

    // Derived metrics
    engagedSessionConversionRate: z.number(),
    engagedSessionConversionRatePercentChange: z.number(),
    sessionConversionRate: z.number(),
    sessionConversionRatePercentChange: z.number(),
    ordersGenerated: z.number(),
    engagementRate: z.number(),
    engagementRatePercentChange: z.number(),

    // Other metrics
    deflectedTickets: z.number(),
    deflectedTicketsPercentChange: z.number(),
    productRecommendations: z.number(),
    productRecommendationsPercentChange: z.number(),

    // Time series and categorical data
    categories: z.array(z.object({ topic: z.string(), count: z.number() })),
    sessionTimeSeries: z.array(
      z.object({
        date: z.string(),
        sessionsCheckoutCompleted: z.number(),
        sessionsWithConciergeAttributedCheckoutCompleted: z.number(),
        sessionsWithConciergeInteracted: z.number(),
        sessionsWithConciergePresent: z.number(),
      }),
    ),
    salesTimeSeries: z.array(
      z.object({ date: z.string(), totalSales: z.number() }),
    ),
    currency: z.string(),
  }),
};
